import { Application } from "../Application";
import { ElementData } from "../Data/ElementData";
import { InteruptType, VoiceCategory } from "../GameObjects/VoiceOverManager";
import { WorldElement } from "../GameObjects/WorldElement";
import { BoxCollider } from "../Physics/BoxCollider";

export class OnboardingPrompt extends WorldElement {
    private _vo: string;

    constructor(pVo: string) {
        super();
        this._vo = pVo;

        this._collider = new BoxCollider(75, 80, -2000, 2000);
    }

    public onCollision(pIsBalloonInvuln: boolean): void {
        super.onCollision(pIsBalloonInvuln);

        Application.instance.voiceOver.play(
            this._vo,
            InteruptType.EQUAL,
            VoiceCategory.INSTRUCTIONAL,
        );
    }
}
